import React from "react";
import CourseListingTabs from "../../components/student-dashboard/course-listing";
// import OliveLogo from "../assets/images/olivegroup-logo.svg";

function CustompageCourseListing() {
  return (     
          <CourseListingTabs />
  );
}

export default CustompageCourseListing;
